import { render } from "./jyps.vue?vue&type=template&id=6294e5e8&scoped=true&ts=true"
import script from "./jyps.vue?vue&type=script&lang=ts"
export * from "./jyps.vue?vue&type=script&lang=ts"

import "./jyps.vue?vue&type=style&index=0&id=6294e5e8&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6294e5e8"]])

export default __exports__